'use client';

import { useState } from 'react';
import { PlayerRef } from '@remotion/player';
import {
  Segmented,
  SegmentedContainer,
  SegmentedContent,
  SegmentedItem,
} from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';
import SoundEffectContent from '../sound-effect/SoundEffectContent';
import BgmContent from './BgmContent';

interface AudioContentProps {
  playerRef: React.RefObject<PlayerRef | null>;
}

type AudioTab = 'sound-effect' | 'bgm';

export default function AudioContent({ playerRef }: AudioContentProps) {
  const t = useTranslations();
  const [activeTab, setActiveTab] = useState<AudioTab>('sound-effect');

  return (
    <div className="absolute flex h-full w-full flex-col">
      <Segmented
        value={activeTab}
        onValueChange={(value) => {window.dispatchEvent(new CustomEvent('property-audio-item-stop'));setActiveTab(value as AudioTab);}}
        size="md"
        // 두 탭의 content를 미리 mount해두면 BGM query가 선언적으로 먼저 실행되어
        // 탭 전환 시 imperative prefetch 없이도 첫 로딩 깜빡임을 줄일 수 있다.
        keepMounted
        className="flex min-h-0 flex-1 flex-col"
      >
        <div className="px-md py-sm">
          <SegmentedContainer>
            <SegmentedItem value="sound-effect">
              {t('Editor.audio-panel.tab.sound-effect')}
            </SegmentedItem>
            <SegmentedItem value="bgm">
              {t('Editor.audio-panel.tab.bgm')}
            </SegmentedItem>
          </SegmentedContainer>
        </div>

        <SegmentedContent
          value="sound-effect"
          className="min-h-0 flex-1"
        >
          <SoundEffectContent playerRef={playerRef} />
        </SegmentedContent>

        <SegmentedContent
          value="bgm"
          className="min-h-0 flex-1"
        >
          {/* 효과음 탭과 분리해 API 조회/재생/추가 로직을 작게 유지한다. */}
          <BgmContent playerRef={playerRef} />
        </SegmentedContent>
      </Segmented>
    </div>
  );
}
